import axiosInstance from "../axiosinstance";

/** @typedef {"start" | "end"} TaskType */

/**
 * @typedef {Object} TaskListProcess
 * @property {string} process_id
 * @property {string} process_name
 * @property {string} process_code
 * @property {string} status
 * @property {string|null} start_eta
 * @property {string|null} end_eta
 * @property {number|null} duration_eta
 * @property {string} equipment_id
 * @property {string} equipment_number
 * @property {string} equipment_group
 * @property {string} project_tz
 */

export const taskListQueryKey = ({
  projectId,
  activeTaskType,
  page,
  pageSize,
  search,
  equipmentGroupId,
}) => [
  "task-list",
  projectId,
  activeTaskType,
  page,
  pageSize,
  search,
  equipmentGroupId,
];

export async function getTaskList(params, signal) {
  const {
    projectId,
    activeTaskType,
    page,
    pageSize,
    search,
    equipmentGroupId,
  } = params;
  const endpoint =
    activeTaskType === "end" ? "ready-to-end" : "ready-to-start";
  const response = await axiosInstance.get(
    `/api/v2/processes/${endpoint}/${encodeURIComponent(projectId)}`,
    {
      params: {
        page,
        page_size: pageSize,
        ...(search ? { search } : {}),
        ...(equipmentGroupId
          ? { equipment_group_id: equipmentGroupId }
          : {}),
      },
      signal,
    },
  );
  return response.data;
}

export async function getTaskListEquipmentGroups(_projectId, signal) {
  const response = await axiosInstance.get(
    "/api/get_all_equipment_groups",
    {
      params: { page: 1, per_page: 1000 },
      signal,
    },
  );
  const groups = Array.isArray(response.data?.data) ? response.data.data : [];
  return groups.map((group) => ({
    equipment_group_id: group.id,
    equipment_group_code: group.equipment_group_code,
    equipment_group_name: group.equipment_group_name,
  }));
}
